/**
 * This is a query for the RequestForm component that retrieves all the
 * pre-checked provider categories that will be used for the PLA Specialty
 * form.
 */

export const providerCategoriesQuery = () => {
  return `preCheckedProvidersCollection(order: name_ASC){
    items{
      categoryName
      name
      preCheckedProviderCategories
    }
  }`
}
